import { render, staticRenderFns } from "./watchrisk-main.vue?vue&type=template&id=2e0b67c8&"
import script from "./watchrisk-main.vue?vue&type=script&lang=js&"
export * from "./watchrisk-main.vue?vue&type=script&lang=js&"
import style0 from "./watchrisk-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports